import { createContext, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loginUser, signupUser, logout as logoutAction, clearAuthError } from '../store/actions/authActions';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const dispatch = useDispatch();
  const { token, user, isAuthenticated, loading, error } = useSelector((state) => state.auth);

  const login = (userData) => dispatch(loginUser(userData));
  const signup = (userData) => dispatch(signupUser(userData));
  const logout = () => dispatch(logoutAction());
  const clearError = () => dispatch(clearAuthError());

  return (
    <AuthContext.Provider
      value={{
        token,
        user,
        isAuthenticated: !!token && isAuthenticated,
        loading,
        error,
        login,
        signup,
        logout,
        clearError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}

export function getAuthToken() {
  try {
    const persistRoot = localStorage.getItem('persist:root');
    if (persistRoot) {
      const parsed = JSON.parse(persistRoot);
      if (parsed.auth) {
        const authState = JSON.parse(parsed.auth);
        return authState.token || null;
      }
    }
  } catch (e) {
    console.warn('getAuthToken:', e);
  }
  return localStorage.getItem('storehub_token') || sessionStorage.getItem('storehub_token');
}

export function getAuthHeaders() {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
